class ArticleNavigation {
  constructor() {
    this.shareButton = document.querySelector('.article-navigation__link--share');
    this.sharePopup = document.querySelector('.article-navigation__share-popup');
    this.copyButton = document.querySelector('.article-navigation__share-icon--copy');
    this.shareUrl = '';
    this.init();
  }

  init() {
    if (this.shareButton && this.sharePopup) {
      this.shareUrl = this.shareButton.getAttribute('data-share-url');
      this.shareButton.addEventListener('click', this.toggleSharePopup.bind(this));
      
      // Close popup when clicking outside
      document.addEventListener('click', this.handleOutsideClick.bind(this));
      
      // Close popup when clicking on social links (they open in new tab)
      const socialLinks = this.sharePopup.querySelectorAll('.article-navigation__share-icon:not(.article-navigation__share-icon--copy)');
      socialLinks.forEach(link => {
        link.addEventListener('click', () => {
          setTimeout(() => {
            this.sharePopup.classList.remove('active');
          }, 100);
        });
      });
    }

    if (this.copyButton) {
      this.copyButton.addEventListener('click', this.handleCopyLink.bind(this));
    }
  }

  toggleSharePopup(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (this.sharePopup.classList.contains('active')) {
      this.sharePopup.classList.remove('active');
    } else {
      // Position popup below share button on mobile (centered via CSS)
      if (window.innerWidth < 768 && this.shareButton && this.sharePopup) {
        const buttonRect = this.shareButton.getBoundingClientRect();
        const top = buttonRect.bottom + 8; // 8px spacing (var(--space-sm))
        this.sharePopup.style.top = `${top}px`;
      }
      
      this.sharePopup.classList.add('active');
    }
  }

  handleOutsideClick(e) {
    if (this.sharePopup && this.sharePopup.classList.contains('active')) {
      const wrapper = this.sharePopup.closest('.article-navigation__share-wrapper');
      if (wrapper && !wrapper.contains(e.target)) {
        this.sharePopup.classList.remove('active');
      }
    }
  }

  async handleCopyLink(e) {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      await navigator.clipboard.writeText(this.shareUrl);
      
      // Show feedback
      const originalHTML = this.copyButton.innerHTML;
      this.copyButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/></svg>';
      this.copyButton.style.color = 'rgba(var(--color-green), 1)';
      
      setTimeout(() => {
        this.copyButton.innerHTML = originalHTML;
        this.copyButton.style.color = '';
      }, 2000);
    } catch (err) {
      // Fallback for older browsers
      const input = document.createElement('input');
      input.value = this.shareUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      
      const originalHTML = this.copyButton.innerHTML;
      this.copyButton.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/></svg>';
      this.copyButton.style.color = 'rgba(var(--color-green), 1)';
      
      setTimeout(() => {
        this.copyButton.innerHTML = originalHTML;
        this.copyButton.style.color = '';
      }, 2000);
    }
    
    // Close popup after copying
    if (this.sharePopup) {
      this.sharePopup.classList.remove('active');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ArticleNavigation();
  });
} else {
  new ArticleNavigation();
}